const childRoutes = prop => [
    {
        path: 'patient-registration-list',
        name: prop + '.patient_registration_list',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/List.vue')
    },
    {
        path: 'patient-registration-approval',
        name: prop + '.patient_registration_approval',
        meta: { auth: true },
        component: () => import('../pages/patient-registration-approval/List.vue')
    },
    {
        path: 'out-expense',
        name: prop + '.out_expense',
        meta: { auth: true },
        component: () => import('../pages/out-expense/List.vue')
    },
    {
        path: 'service-delivery-out',
        name: prop + '.service_delivery_out',
        meta: { auth: true },
        component: () => import('../pages/out-expense/ServiceDeliveryOut.vue')
    },
    {
        path: 'service',
        name: prop + '.service_information',
        meta: { auth: true },
        component: () => import('../pages/service-information/List.vue')
    },
    {
        path: 'service-info-add',
        name: prop + '.service_information',
        meta: { auth: true },
        component: () => import('../pages/service-information/Form.vue')
    },
    {
        path: 'service-info-details',
        name: prop + '.service_information',
        meta: { auth: true },
        component: () => import('../pages/service-information/Details.vue')
    },
    {
        path: 'registration-list',
        name: prop + '.registration_list',
        meta: { auth: true },
        component: () => import('../pages/registration-list/List.vue')
    },
    {
        path: 'patient-add-approval',
        name: prop + '.registration_list',
        meta: { auth: true },
        component: () => import('../pages/patient-registration-approval/Form.vue')
    },
    {
        path: 'patient-add',
        name: prop + '.registration_list',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/Form.vue')
    },
    {
        path: 'patient-details',
        name: prop + '.registration_list',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/Details.vue')
    },
    {
        path: 'service-delivery',
        name: prop + '.service_delivery',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/ServiceDelivery.vue')
    },
    {
        path: 'view-service-delivery',
        name: prop + '.view_service_delivery',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/DeliveryDetails.vue')
    },
    {
        path: 'patient-add',
        name: prop + '.registration_list',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/Form.vue')
    },
    {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/dashboard/List.vue')
    },
    {
        path: 'samiti-application-form',
        name: prop + '.samiti_application_form',
        meta: { auth: true },
        component: () => import('../pages/samiti-application-form/List.vue')
    },
    {
        path: 'samiti-application-add',
        name: prop + '.samiti_application_add',
        meta: { auth: true },
        component: () => import('../pages/samiti-application-form/Add.vue')
    },
    {
        path: 'bank-details',
        name: prop + '.bank_details',
        meta: { auth: true },
        component: () => import('../pages/bank-details/List.vue')
    },
    {
        path: 'store-details',
        name: prop + '.store_details',
        meta: { auth: true },
        component: () => import('../pages/store-details/List.vue')
    },
    {
        path: 'bank-withdrawal',
        name: prop + '.bank_withdrawal',
        meta: { auth: true },
        component: () => import('../pages/bank-withdrawal/List.vue')
    }
]
const routes = [
    {
        path: '/hospital-disability-service/information',
        name: 'hospital_disability_service.information',
        component: () => import('@/layouts/HospitalDisabilityService.vue'),
        meta: { auth: true },
        children: childRoutes('hospital_disability_service.information')
    }
]

export default routes
